import React, { useState, useRef, useEffect } from 'react';
import ThemeControls from '../AllThemesControl';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import { BsXLg, BsX } from 'react-icons/bs';
import IconButton from '@mui/material/IconButton';
import { APIGET, APIPOST , APIAUTHDOWNLOAD} from '../../services/APIServices'
import SuccessPage from '../SuccessPage';
import * as XLSX from 'xlsx';

const generateMailBody = (data, columns) => {
  const fieldValues = {};
  // //console.log(data)
  // Populate field values based on temp_id references
  data.forEach((item) => {
    // //console.log(item)
    const { field_id, temp_id, field_value, field_type } = item
    if (field_type === 'body' && Array.isArray(field_value)) {
      fieldValues[field_id] = generateTableHTML(field_value, columns);
    } else {
      fieldValues[field_id] = field_value;
    }
  });
  // //console.log(fieldValues)
  // Construct mail body using field values

  // ${fieldValues.mailBodyContent}
  const mailBody = `<div style="text-align: left;"><br><p style="color: rgb(168, 0, 0);">Dear Partner,<br><br>Kindly find attached full Replacement Rate Notification from GTS, Kindly use the correct prefix when sending traffic.</p><br>
${fieldValues.mailbody}
<br>

<p style="color: rgb(168, 0, 0);">
<br>
Thanks & Regards,<br>
${fieldValues.amName}
</p>
</div>`;

  return mailBody;
};

const generateTableHTML = (data, columns) => {
  //console.log(data)
  const headerRow = `<tr>${columns.map(header => `<th style="text-align: left;border: 1px solid black; padding: 4px 8px">${header.title}</th>`).join('')}</tr>`;
  const bodyRows = data && data?.map(row => `<tr>${columns.map(header => `<td style="text-align: left;border: 1px solid black;padding: 4px 8px">${row[header.dataIndex]}</td>`).join('')}</tr>`).join('');
  return `<table style="border: 1px solid black; border-collapse: collapse;">
      <thead>${headerRow}</thead>
      <tbody>${bodyRows}</tbody>
    </table>`;
};

export default function EmailTemplate({ close, contextJson, apiContextObj, viewJson}) {
   
  const [apiPath, setApiPath] = useState("");
  const [emailJson, setEmailJson] = useState(viewJson[apiContextObj?.mailFlow?.sendJson]);
  const [loading, setLoading] = useState(true);
  const [fileData, setFileData] = useState('');
  const columns = viewJson[apiContextObj?.mailFlow?.columns];
  let formattedString = "";

  useEffect(() => {
    const searchData = {};
    Object.keys(contextJson).forEach((key, index) => {
      if (key !== "xioFEConfig") {
        contextJson[key].fields.forEach((field) => {
          searchData[field.field_id.toLowerCase()] = field.field_value;
        });
      }
    });

    const id = apiContextObj.mailFlow.apiContextGet.id;
    if (typeof id === 'string') {
      setApiPath(apiContextObj.mailFlow.apiContextGet.apiContext);
    } else if (Array.isArray(id)) {
      id.forEach((key) => {
        const value = searchData[key.toLowerCase()];
        if (value !== undefined) {
          formattedString += `${key}=${encodeURIComponent(value)}&`;
        }
      });
      const APIPath = apiContextObj.mailFlow.apiContextGet.apiContext + formattedString;
      setApiPath(APIPath);
    } else {
       
    }
  }, [contextJson, apiContextObj.mailFlow.apiContextGet]);

  useEffect(() => {
    async function fetchData() {
      if (apiPath) {
        const searchData = {};
        Object.keys(contextJson).forEach((key, index) => {
          if (key !== "xioFEConfig") {
            contextJson[key].fields.forEach((field) => {
              searchData[field.field_id.toLowerCase()] = field.field_value;
            });
          }
        });
        try {
          const data = await APIGET(apiPath);
           
          if (data.data) {
            const _data = { ...data.data, ...searchData };
             
            const tempJson = emailJson.map((field) => {
              if (typeof field.temp_id === 'string') {
                field.field_value = _data[field.temp_id];
              } else if (Array.isArray(field.temp_id)) {
                let tempData = field.temp_id.map((key) => _data[key]);
                field.field_value = tempData.join(', ');
              }
              return field;
            });
            setEmailJson(tempJson);
            setFileData(data.data.path)     
          }
        } catch (error) {
          console.error('Error fetching data:', error);
        } finally {
          setLoading(false);
        }
      }
    }

    fetchData();
  }, [apiPath]);


  return (
    <>{loading&&fileData.length===0?<div style={{ width: '1000px',height: '400px', '@media (min-width: 400px)': { width: '304px',height: '200px', } }}>
        <div className='loader'></div>
    </div>:
    <EmailTemplateForm close={close} data={emailJson} fileData={fileData} columns={columns} apiContextObj={apiContextObj} contextJson={contextJson}/>
    }
    </>
  );
}


// const generateHeaders = (carrierId) => {
//   if (carrierId != 805903){
//     return (
//       [
//         {
//             "title": "Destination",
//             "dataIndex": "destination"
//         },
//         {
//             "title": "Code",
//             "dataIndex": "code"
//         },
//         {
//             "title": "Rate",
//             "dataIndex": "rate"
//         },
//         {
//             "title": "Techprefix",
//             "dataIndex": "techprefix"
//         },
//         {
//             "title": "EffectiveDate",
//             "dataIndex": "effectiveDate"
//         },
//         {
//             "title": "Quality",
//             "dataIndex": "quality"
//         },
//         {
//             "title": "Remark",
//             "dataIndex": "remark"
//         },
//         {
//             "title": "Min Duration",
//             "dataIndex": "minduration"
//         },
//         {
//             "title": "Incremental",
//             "dataIndex": "incr"
//         }
//     ]
//     )
//   }else{
//     return (
//       [
//         {
//             "title": "Destination",
//             "dataIndex": "destination"
//         },
//         {
//             "title": "Area Code",
//             "dataIndex": "code"
//         },
//         {
//             "title": "New Price",
//             "dataIndex": "rate"
//         },
//         {
//             "title": "Price Valid From",
//             "dataIndex": "effectiveDate"
//         },
//         {
//             "title": "Remarks",
//             "dataIndex": "remark"
//         },
//         {
//             "title": "Billing Increment",
//             "dataIndex": "billingIncr"
//         }
//     ]
//     )
//   };
 
// };


// const generateXLSX = (dataSheets, headersSheets, dynamicData) => {
//   const workbook = XLSX.utils.book_new();

//   // Add first sheet
//   const data = dataSheets[0];
//   const headers = headersSheets[0];
//   const filteredData = data?.map(item =>
//     headers.reduce((acc, header) => {
//       acc[header.title] = item[header.dataIndex];
//       return acc;
//     }, {})
//   );
//   const worksheet1 = XLSX.utils.json_to_sheet(filteredData);
//   XLSX.utils.book_append_sheet(workbook, worksheet1, 'Sheet 1');

//   // Add second sheet with dynamic data
//   const dynamicWorksheet = XLSX.utils.json_to_sheet(dynamicData);
//   XLSX.utils.book_append_sheet(workbook, dynamicWorksheet, 'Sheet 2');

//   const xlsBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
//   return new Blob([xlsBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
// };

// const downloadXLS = (dataSheets, headersSheets, dynamicData, filename) => {
//   const xlsBlob = generateXLSX(dataSheets, headersSheets, dynamicData);
//   const url = URL.createObjectURL(xlsBlob);
//   const link = document.createElement('a');

//   link.setAttribute('href', url);
//   link.setAttribute('download', filename);
//   document.body.appendChild(link);
//   link.click();
//   document.body.removeChild(link);
// };



const EmailTemplateForm = ({ data, close, columns, apiContextObj, contextJson, fileData }) => {
  const { useStyles } = ThemeControls;
  const classes = useStyles();
  const ref = useRef();
  const [templateContent, setTemplateContent] = useState(generateMailBody(data, columns));
  const [allTo, setAllTo] = useState([]);
  const [allCc, setAllCc] = useState([]);
  const [allBcc, setAllBcc] = useState([]);
  const [to, setTo] = useState('');
  const [cc, setCc] = useState('');
  const [bcc, setBcc] = useState('');
  const [subject, setSubject] = useState("");
  const [ccOpen, setCcOpen] = useState(true);
  const [bccOpen, setBccOpen] = useState(false);
  const [allMailDisplay, setAllMailDisplay] = useState(true);
  const [currentField, setCurrentField] = useState('');
  const [successRender, setSuccessRender] = React.useState(undefined);
  const [successPageData, setSuccessPageData] = React.useState(undefined);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setAllMailDisplay(true);
        if (!cc && !bcc) {
          // setCcOpen(false);
          setBccOpen(false);
        } else if (!cc) {
          // setCcOpen(false);
        } else if (!bcc) {
          setBccOpen(false);
        }
      }
    };
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ',') {
      event.preventDefault();
      // addEmailToList();
    }
  };

  const addEmailToList = () => {
    const trimmedEmail = currentField.trim();
    //console.log(trimmedEmail)
    if (isValidEmail(trimmedEmail)) {
      if (currentField === to) {
        setAllTo((prevTo) => [...prevTo, trimmedEmail]);
        setTo('');
      } else if (currentField === cc) {
        setAllCc((prevTo) => [...prevTo, trimmedEmail]);
        setCc('');
      } else if (currentField === bcc) {
        setAllBcc((prevTo) => [...prevTo, trimmedEmail]);
        setBcc('');
      }
    } else {
      alert('Invalid email format. Please enter a valid email.');
    }
  };

  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };
  function checkEmails(input) {
    const emails = input.split(/[, ]+/).filter(email => email.trim() !== '');

    return emails.every(email => isValidEmail(email.trim()));
}

  const removeEmail = (index, field) => {
    if (field === 'to') {
      setAllTo((prevTo) => {
        const updatedTo = [...prevTo];
        updatedTo.splice(index, 1);
        return updatedTo;
      });
    } else if (field === 'cc') {
      setAllCc((prevTo) => {
        const updatedTo = [...prevTo];
        updatedTo.splice(index, 1);
        return updatedTo;
      });
    } else if (field === 'bcc') {
      setAllBcc((prevTo) => {
        const updatedTo = [...prevTo];
        updatedTo.splice(index, 1);
        return updatedTo;
      });
    }
  };

  const handleFieldChange = (value, id) => {
    setCurrentField(value);
    data.forEach((field)=>{
      if(field.field_id===id){
        field.field_value=value
      }
    })
    // if (field === 'to') setTo(event.target.value);
    // else if (field === 'cc') setCc(event.target.value);
    // else if (field === 'bcc') setBcc(event.target.value);
    // else if (field === 'subject') setSubject(event.target.value);
    // else if (field === 'emailContent') setTemplateContent(event.target.value);
  };

  const handleCcClick = () => {
    setCcOpen(true);
  };

  const handleBccClick = () => {
    setBccOpen(true);
  };

  function arrayToString(arr) {
    return arr.join(', ');
  }
function cancelMail(){
  let APIPath=''
  const searchData={}
  data.forEach((field)=>{
    searchData[field.field_id.toLowerCase()] = field.field_value;

  })
  const id = apiContextObj.mailFlow.apiContextDelete.id;
    if (typeof id === 'string') {
      APIPath = apiContextObj.mailFlow.apiContextDelete.apiContext;
    } else if (Array.isArray(id)) {
      let formattedString = "";
      id.forEach((key) => {
        const value = searchData[key.toLowerCase()];
        if (value !== undefined) {
          formattedString += `${key}=${encodeURIComponent(value)}&`;
        }
      });
     APIPath = apiContextObj.mailFlow.apiContextDelete.apiContext + formattedString;
}

if(APIPath){
  fetchData(APIPath)
}
}
  async function fetchData(APIPath) {
      try {
        const data = await APIGET(APIPath);
        if (data&&data.statusCode==='SUCCESS') {
        close()
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
  }

  function renderSuccessPage(props) {
    // console.log(props)
    setSuccessPageData(props)
    setSuccessRender(1);
  }

      function handleErrorMsg(msg){
        alert(msg)
      }

  async function postingData(mailData) {
    try {
        const response = await APIPOST(apiContextObj.mailFlow.apiContext, mailData,contextJson, renderSuccessPage, {});
        //console.log(response)
        if (response) {
            const responseData = await response.json(); // Assuming response is a JSON object
             
            return responseData;
        }
    } catch (error) {
        console.error(error);
        throw error;
    }
}
  const handleSendTemplate = (event) => {
    event.preventDefault();
    const mailData={}
    let isValid=true
    const mailBodyHTML = document.getElementById('mailbody').innerHTML;
    data.forEach((field)=>{
      mailData[field.field_id]=field.field_value
    })
    const emailPayload = {
      ...mailData,
      mailbody: mailBodyHTML,
    };
    if (isValid) {
      // console.log(mailData)
      postingData(emailPayload)
    
    } else {
      alert('Please specify at least one recipient.')
    }
  };

  const mergeAllArrays = () => {
    return [...allTo, ...allCc, ...allBcc];
  };
  const mergedArray = mergeAllArrays();
  
  console.log(data)

  // const handleDownload = (filename) => {
  //   const mailData={}
  //   data.forEach((field)=>{
  //     mailData[field.field_id]=field.field_value
  //   })
  //   if(fileData.length>0){
  //     const headers = generateHeaders(data[0]['field_value']);
  //     console.log(headers)
  //     downloadXLS(fileData, headers, filename, mailData.mailBodyContent);
  //   }
  // };

  async function handleDownload(fileName, path) {
    if (fileName) {
      try {
          const data = await APIAUTHDOWNLOAD('ratesheet/rs/gtsRatesheetWF/getratesheetdata?filepath=' + path);
          if (data) {
              const blob = new Blob([data]);
              const url = window.URL.createObjectURL(blob);
              const link = document.createElement('a');
              link.href = url;
              link.download = fileName;
              document.body.appendChild(link);
              link.click();
              window.URL.revokeObjectURL(url);
              console.log("File Download: Done");
          } else {
              alert('No data in file');
          }
      } catch (error) {
          console.error('Error fetching data:', error);
      } finally {
      }
  } else {
      console.error('File name is missing');
  }
}

  return (
    <div  style={{ width: '1000px', '@media (min-width: 400px)': { width: '304px',height: '304px' } }}>
        <div className={classes.emailMsgHeading}>
        <span>New Message</span>
        <IconButton onClick={close}>
          <BsX />
        </IconButton>
      </div>
      {(successRender) ?
        <SuccessPage
          flowName={apiContextObj.contextHeading}
          actionName="sent"
        />
        :
      <div className={classes.emailTemplate}>
        {allMailDisplay ?
          <div ref={ref}>
            {
              data?.map((field) => {
                //console.log(field)
                if (field.field_type === "to") {

                  return (
                    <div className='flx'>
                      <div className='mailTo' key={field.field_id}>
                        <label htmlFor='to'>To</label>
                        {allTo.map((item, index) => (
                          <span className='bachLabel' key={index}>
                            {item}
                            <BsXLg onClick={() => removeEmail(index, 'to')} />
                          </span>
                        ))}
                        <input
                          type='text'
                          id={field.field_id}
                          value={field.field_value}
                          onChange={(event) => {handleFieldChange(event.target.value, field.field_id);setTo(event.target.value)}}
                          onKeyDown={handleKeyDown}
                          autoFocus
                        />
                      </div>
                      <div className='ccBtn flx'>
                        {!ccOpen && <label onClick={handleCcClick}>Cc</label>}
                        {!bccOpen && <label onClick={handleBccClick}>Bcc</label>}
                      </div>
                    </div>
                  );
                } else if (field.field_type === "cc") {
                  return (
                    <>
                      {ccOpen && (
                        <div className='flx'>
                          <label htmlFor='cc'>Cc</label>
                          {allCc.map((item, index) => (
                            <span className='bachLabel' key={index}>
                              {item.trim()}
                              <BsXLg onClick={() => removeEmail(index, 'cc')} />
                            </span>
                          ))}
                          <input
                            type='text'
                            id={field.field_id}
                            value={field.field_value}
                            onChange={(event) => handleFieldChange(event.target.value, field.field_id)}
                            onKeyDown={handleKeyDown}
                            autoFocus
                          />
                        </div>
                      )}
                    </>
                  )
                } else if (field.field_type === "bcc") {
                  return (
                    <>
                      {bccOpen && (
                        <div className='flx'>
                          <label htmlFor='bcc'>Bcc</label>
                          {allBcc.map((item, index) => (
                            <span className='bachLabel' key={index}>
                              {item.trim()}
                              <BsXLg onClick={() => removeEmail(index, 'bcc')} />
                            </span>
                          ))}
                          <input
                            type='text'
                            id='bcc'
                            value={bcc}
                            onChange={(event) => handleFieldChange(event.target.value, field.field_id)}
                            onKeyDown={handleKeyDown}
                            autoFocus
                          />
                        </div>
                      )}
                    </>
                  )
                } else  if (field.field_type === "fileName") {

                  return (
                     <div className='flx'>
                      <label htmlFor='file'>Attachment</label>
                      {/* <a href="" download>field.field_value</a> */}
                      <input
                        type='text'
                        id={field.field_id}
                        value={field.field_value}
                        placeholder='FileName'
                        readOnly
                        style={{color: 'blue', cursor: 'pointer'}}
                        onClick={()=>handleDownload(field.field_value, fileData)}
                      />
                    </div>
                  )
                } else {
                  return null;
                }
              })
            }
          </div> :
          <div onClick={() => setAllMailDisplay(true)} className="allEmail">
            {mergedArray.length > 0 ? <label>{mergedArray.join(', ')}</label> : <label>Recipients</label>}
          </div>
        }
        {
          data.map((field) => {
            //console.log(field)
           if (field.field_type === "subject") {
              return (
                <div className='flx subjBord'>
                <input
                  type='text'
                  id={field.field_id}
                  value={field.field_value}
                  onChange={(event) => handleFieldChange(event.target.value, field.field_id)}
                  placeholder='Subject'
                />
              </div>
              )
            } else if (field.field_type === "body") {

              return (
                <div className='mailBody'
                  contentEditable
                  id={field.field_id}
                  dangerouslySetInnerHTML={{ __html: generateMailBody(data, columns) }}
                  // onBlur={(e)=>handleFieldChange(e.target.innerHTML,field.field_id)}
                />
              )
            } else {
              return null;
            }
          })
        }

        <div>

        </div>
        <div className='sendBtn'>
          <button
            type='submit'
            className='btnSendMail'
            variant='contained'
            sx={{ borderRadius: '25px', mr: 1 }}
            onClick={handleSendTemplate}
          >
            Send
          </button>
          <button
            type='cancel'
            className='btnSendCancle'
            variant='contained'
            sx={{ borderRadius: '25px', backgroundColor: '#969292' }}
            onClick={cancelMail}
          >
            Cancel
          </button>
        </div>
      </div>
      }
    </div>
  );
};
